import React from "react";
import styled from "@emotion/styled";
import { GameItem } from "./GameItem";

import battlerushArenaAppIcon from "../../../images/app-icon.jpg";
import { BATTLERUSH_ARENA_TITLE } from "../../../constants";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const Content = styled.div`
  width: 50%;
`;

interface Game {
  title: string;
  description: string;
  image: string;
  appStoreUrl: string;
  googlePlayStoreUrl: string;
}

const games: Game[] = [
  {
    title: BATTLERUSH_ARENA_TITLE,
    description: `${BATTLERUSH_ARENA_TITLE} is a competitive online math game where the objective is to solve puzzles faster than your opponent.
      Equip and level your hero up with rare items, and work hard to place higher on the leaderboard. ${BATTLERUSH_ARENA_TITLE} is on iOS and Android.`,
    image: battlerushArenaAppIcon,
    appStoreUrl: 'https://apps.apple.com/us/app/battlerush-arena/id1558786731',
    googlePlayStoreUrl: 'https://play.google.com/store/apps/details?id=com.hightailgames.battlerusharena&hl=en_US&gl=US',
  },
];

export const Games: React.FC = (props) => {
  return (
    <Container>
      <Content>
        {games.map((game) => {
          return <GameItem {...game} />;
        })}
      </Content>
    </Container>
  );
};
